import { CAKE_URL, WEB_API_URL } from 'src/helpers/globals';

const formatQueryParamString = (params: Record<string, string>) => {
  const hasParams = params && Object.keys(params).length !== 0;
  if (!hasParams) {
    return '';
  }
  const searchParams = new URLSearchParams(params);
  const queryString = searchParams.toString();
  return `?${queryString}`;
};

export const sellerFlowPagePath = ({ token, slug, inApp = false }) => {
  let path = slug ? `/seller-lead/${token}/${slug}` : `/seller-lead/${token}`;
  if (inApp) {
    path = `${path}?app=1`;
  }
  return path;
};

export const sellerGlobalPagePath = ({ token, page, inApp = false }) => {
  let path = `/seller-lead/${token}/p/${page}`;
  if (inApp) {
    path = `${path}?app=1`;
  }
  return path;
};

export const offerDashboardPath = (addressUUID: string, queryParams?: Record<string, string>) => {
  let path = `${CAKE_URL}/dashboard/sell/${addressUUID}`;
  if (queryParams) {
    const queryParamStr = formatQueryParamString(queryParams);
    path += queryParamStr;
  }
  return path;
};

export const addressEntryPath = () => `${WEB_API_URL}/address-entry?msg=lead-not-found`;

export const errorPagePath = (params?: {
  slug?: string;
  page?: string;
  code?: string;
  leadToken?: string;
}) => {
  const queryString = formatQueryParamString(params as Record<string, string>);
  return `/seller-lead/error${queryString}`;
};
